var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('td',{class:{ toggle: true, active: _vm.active, open: _setup.open },on:{"click":function($event){return _setup.toggle()}}},[(_vm.active)?_c('i',{staticClass:"material-icons"},[_vm._v("chevron_right")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }